import script from "./InterviewQuestionary.vue?vue&type=script&lang=ts&setup=true"
export * from "./InterviewQuestionary.vue?vue&type=script&lang=ts&setup=true"

import "./InterviewQuestionary.vue?vue&type=style&index=0&id=35dcba3e&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35dcba3e"]])

export default __exports__